import { DataDogCustomConfig } from '@lib/services';

/**
 * Datadog（ログ）構成
 *
 * @see {@link DataDogCustomConfig}
 */
export const DATADOG_CONFIG: DataDogCustomConfig = {
  service: 'aswbe:spa:reservation',
  replaceRules: {
    // パスワード：全桁をマスクする
    password: ['.', '*'],
  },
};
